import clsx from 'clsx';
import { ButtonVariant, ButtonSize } from './types';

export const styles = {
  base: clsx(
    'tw-inline-flex tw-items-center tw-justify-center tw-font-medium tw-rounded tw-border',
    'tw-transition-all tw-duration-150 tw-ease-in-out'
  ),

  variants: {
    primary: clsx(
      'tw-bg-primary-600 tw-text-white tw-border-transparent',
      'hover:tw-bg-primary-700',
      'tw-shadow-sm hover:tw-shadow-md'
    ),
    secondary: clsx(
      'tw-bg-neutral-100 tw-text-neutral-700 tw-border-transparent',
      'hover:tw-bg-neutral-200'
    ),
    success: clsx(
      'tw-bg-success-500 tw-text-white tw-border-transparent',
      'hover:tw-bg-success-600',
      'tw-shadow-sm hover:tw-shadow-md'
    ),
    danger: clsx(
      'tw-bg-danger-500 tw-text-white tw-border-transparent',
      'hover:tw-bg-danger-600',
      'tw-shadow-sm hover:tw-shadow-md'
    ),
    ghost: clsx(
      'tw-bg-transparent tw-text-neutral-600 tw-border-transparent',
      'hover:tw-bg-neutral-100'
    ),
    'ghost-danger': clsx(
      'tw-bg-danger-50 tw-text-danger-600 tw-border-transparent',
      'hover:tw-bg-danger-100'
    ),
    'ghost-primary': clsx(
      'tw-bg-primary-50 tw-text-primary-600 tw-border-transparent',
      'hover:tw-bg-primary-100'
    ),
    'ghost-success': clsx(
      'tw-bg-success-50 tw-text-success-600 tw-border-transparent',
      'hover:tw-bg-success-100'
    ),
    outline: clsx(
      'tw-bg-white tw-text-neutral-700 tw-border-neutral-300',
      'hover:tw-bg-neutral-50 hover:tw-border-neutral-400'
    ),
  } as Record<ButtonVariant, string>,

  sizes: {
    sm: 'tw-px-3 tw-py-1.5 tw-text-xs tw-gap-1.5',
    md: 'tw-px-4 tw-py-2 tw-text-sm tw-gap-2',
    lg: 'tw-px-5 tw-py-2.5 tw-text-base tw-gap-2',
  } as Record<ButtonSize, string>,

  disabled: 'tw-opacity-60 tw-cursor-not-allowed tw-pointer-events-none',
};
